import { all, call, put, takeLatest } from "redux-saga/effects"
import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { genericGetRequest_2 } from "../../helpers/sf_backend_helper"
import { GET_ADMIN_CHANGE_HISTORY_FILTERS } from "./actionTypes"
import {
  getAdminChangeHistoryFilterError,
  getAdminChangeHistoryFilterSuccess,
} from "./actions"

// Each dropdown has its own endpoint so they load independently of the change
// history grid itself.
export const FILTER_REQUEST_CONCURRENCY = 2

export const ADMIN_CHANGE_HISTORY_FILTER_ENDPOINTS = {
  accounts: "accounts",
  brands: "brands",
  campaigns: "campaigns",
  users: "users",
  admin_users: "admin_users",
  change_location_options: "change_locations",
  change_action_options: "change_actions",
}

function* fetchAdminChangeHistoryFilter(filterKey, path, headers) {
  try {
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_history_version_filters/${path}`,
      {},
      headers,
    )
    yield put(getAdminChangeHistoryFilterSuccess(filterKey, response?.data || []))
  } catch (error) {
    yield put(getAdminChangeHistoryFilterError(filterKey, error))
  }
}

function* onGetAdminChangeHistoryFilters() {
  const user_auth = bsh_getAdminUserDetails()
  const headers = {
    Authorization: user_auth?.token,
    'account-id': user_auth?.account_id,
  }

  const filters = Object.entries(ADMIN_CHANGE_HISTORY_FILTER_ENDPOINTS)
  for (let index = 0; index < filters.length; index += FILTER_REQUEST_CONCURRENCY) {
    const batch = filters.slice(index, index + FILTER_REQUEST_CONCURRENCY)
    yield all(
      batch.map(([filterKey, path]) =>
        call(fetchAdminChangeHistoryFilter, filterKey, path, headers),
      ),
    )
  }
}

function* adminChangeHistoryFiltersSaga() {
  yield takeLatest(GET_ADMIN_CHANGE_HISTORY_FILTERS, onGetAdminChangeHistoryFilters)
}

export default adminChangeHistoryFiltersSaga
